/**
 * While the Content Security Policy is in place, inline styles/scripts are rejected with a nonce data attribute.
 * Those can't be added for CSS Custom Props so we're transferring them from data attributes to inline styles instead.
 *
 */
export default function addCustomPropsForCSP() {
	const elements = document.querySelectorAll('[data-custom-props]')

	if (!elements) return

	Object.keys(elements).forEach((key) => {
		const element = elements[key]
		const props = element.getAttribute('data-custom-props')

		element.style = props
	})
}
